import { useContext } from "react"

import TokenAmountInputMaxButton from "#/shared/components//TokenAmountInput/TokenAmountInputMaxButton"
import TokenAmountInput from "#/shared/components/TokenAmountInput"
import { useDepositInput } from "#/shared/hooks"
import DepositTokenBox from "#/ui-old/Deposit/DepositToken/DepositTokenBox"

import { FlowContext } from "../context"
import { bigIntToFloat } from "../utils"

type DepositInputProps = {
  initialTokenAmount?: string
  placeholder: string
  precisionAmount: number
}

export default function DepositInput({
  initialTokenAmount,
  placeholder,
  precisionAmount,
}: DepositInputProps) {
  const {
    depositAmount,
    tokenDecimals,
    depositFromAnotherWallet,
    maxTokenAmount,
    setDepositTokenAmountCallback,
    additionalValidationCallback,
  } = useDepositInput(initialTokenAmount)

  const { isBitcoinFlow } = useContext(FlowContext)

  return (
    <>
      <TokenAmountInput
        tokenAmount={depositAmount}
        setTokenAmountCallback={setDepositTokenAmountCallback}
        additionalValidationCallback={additionalValidationCallback}
        tokenDecimals={tokenDecimals}
        maxTokenAmount={
          maxTokenAmount
            ? bigIntToFloat(maxTokenAmount, tokenDecimals, tokenDecimals)
            : undefined
        }
        placeholder={placeholder}
        precisionAmount={precisionAmount}
        paddingRight={isBitcoinFlow ? "150px" : "165px"}
        fontSize="26px"
        height="80px"
      />
      <TokenAmountInputMaxButton
        maxTokenAmount={
          maxTokenAmount
            ? bigIntToFloat(maxTokenAmount, tokenDecimals, tokenDecimals)
            : "0"
        }
        setTokenAmount={setDepositTokenAmountCallback}
        right={isBitcoinFlow ? "56px" : "86px"}
        top="30px"
        px={2}
        py={1}
        isDisabled={depositFromAnotherWallet}
        variant={depositFromAnotherWallet ? "disabled" : "primary"}
      >
        max
      </TokenAmountInputMaxButton>
      <DepositTokenBox />
    </>
  )
}
